import React, { FC } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import style from "./style.scss";

export interface MasterProps {
    children: JSX.Element;
}

export const Master: FC<MasterProps> = props => {
    return props.children;
};
// This is need to make sure we find it when sniffing the children
Master.displayName = `${Master.name}`;

export interface DetailProps {
    children: JSX.Element;
}

export const Detail: FC<DetailProps> = (props: DetailProps) => {
    return props.children;
};
// This is need to make sure we find it when sniffing the children
Detail.displayName = `${Detail.name}`;

export interface MasterDetailProps {
    readonly detailPath?: string;
    readonly primary?: "master" | "detail";
    readonly children: JSX.Element | JSX.Element[];
}

/**
 * MasterDetail component inspired by {@link Martin Pritchard https://medium.com/@blewpri/react-responsive-master-detail-10b60b739879}
 */
export const MasterDetail: FC<MasterDetailProps> = (props: MasterDetailProps) => {
    let { detailPath } = props;
    const primary = props.primary ?? "master";
    const { path } = useRouteMatch();

    let master: JSX.Element;
    let detail: JSX.Element;

    React.Children.forEach(props.children, child => {
        if (typeof child.type === "function") {
            if (child.type.name === "Master") {
                master = child;
            } else if (child.type.name === "Detail") {
                detail = child;
            }
        }
    });

    if (!master) {
        throw new TypeError("Could not find child <Master /> in <MasterDetail />");
    }

    if (!detail) {
        throw new TypeError("Could not find child <Detail /> in <MasterDetail />");
    }
    // Clean the detail path if it starts with a /
    if (detailPath && detailPath.startsWith("/")) {
        detailPath = detailPath.substr(1);
    }

    return (
        <section className={style.wrapper}>
            <section className={style.left + " " + (primary === "master" ? style.primary : style.secondary)}>
                <Route path={`${path}`}>{master}</Route>
            </section>
            <section className={style.right + " " + (primary === "detail" ? style.primary : style.secondary)}>
                <div className={style.viewWrap}>
                    <div className={style.detailContent}>
                        <Switch>
                            <Route exact path={`${path}`}>
                                {detail}
                            </Route>
                            <Route path={`${path}/${detailPath}`}>{detail}</Route>
                        </Switch>
                    </div>
                    {/* <SiteFooter /> */}
                </div>

            </section>
        </section>
    );
};
